
import React, { useState } from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import AdminNavbar from '../../components/admin/AdminNavbar';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminBottomNavbar from '../../components/admin/AdminBottomNavbar';

const { Outlet } = ReactRouterDOM as any;

const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-surface text-foreground">
      <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <AdminNavbar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4 sm:p-6 lg:p-8 pb-16 lg:pb-8">
          <Outlet />
        </main>
        <AdminBottomNavbar />
      </div>
    </div>
  );
};

export default AdminLayout;
